import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SellerLayout from './SellerLayout';

const SellerCategoryAdd = () => {
  const [loading, setLoading] = useState(true);
  const [shopName, setShopName] = useState('');
  const [parentCategories, setParentCategories] = useState([]);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const [form, setForm] = useState({
    name: '',
    parent_id: '',
    sort_order: '0',
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get('/api/seller/category/add-data', {
          withCredentials: true,
        });

        if (res.data && res.data.ok) {
          setShopName(res.data.shop_name || '');
          setParentCategories(Array.isArray(res.data.parent_categories) ? res.data.parent_categories : []);
        } else {
          alert(res.data?.error || '데이터를 불러오지 못했습니다.');
        }
      } catch (err) {
        const redirect = err?.response?.data?.redirect;
        const error = err?.response?.data?.error;

        if (redirect) {
          window.location.href = redirect;
          return;
        }

        alert(error || '데이터를 불러오지 못했습니다.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(
        '/api/seller/category/add-process',
        form,
        { withCredentials: true }
      );

      if (res.data && res.data.ok) {
        setMessage(res.data.message || '카테고리가 등록되었습니다.');
        setMessageType('success');

        window.location.href = res.data.redirect || '/seller/category/list';
        return;
      }

      setMessage(res.data?.error || '등록에 실패했습니다.');
      setMessageType('danger');
    } catch (err) {
      setMessage(err?.response?.data?.error || '등록에 실패했습니다.');
      setMessageType('danger');
    }
  };

  if (loading) {
    return (
      <SellerLayout shopName={shopName}>
        <div style={styles.loadingWrap}>
          <div>로딩중...</div>
        </div>
      </SellerLayout>
    );
  }

  return (
    <SellerLayout shopName={shopName}>
      <div style={styles.container}>
        <h2 style={styles.title}>카테고리 추가</h2>

        {message ? (
          <div
            style={messageType === 'success' ? styles.successAlert : styles.dangerAlert}
          >
            {message}
          </div>
        ) : null}

        <form onSubmit={handleSubmit}>
          <div style={styles.mb3}>
            <label style={styles.label}>카테고리 이름</label>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              style={styles.input}
              required
            />
          </div>

          <div style={styles.mb3}>
            <label style={styles.label}>상위 카테고리 (없으면 비워두세요)</label>
            <select
              name="parent_id"
              value={form.parent_id}
              onChange={handleChange}
              style={styles.select}
            >
              <option value="">없음</option>
              {parentCategories.map((row) => (
                <option key={row.id} value={row.id}>
                  {row.name}
                </option>
              ))}
            </select>
          </div>

          <div style={styles.mb3}>
            <label style={styles.label}>정렬 순서</label>
            <input
              type="number"
              name="sort_order"
              value={form.sort_order}
              onChange={handleChange}
              style={styles.input}
            />
          </div>

          <button type="submit" style={styles.submitButton}>
            카테고리 등록
          </button>
        </form>
      </div>
    </SellerLayout>
  );
};

const styles = {
  loadingWrap: {
    minHeight: '300px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Noto Sans KR', sans-serif",
  },
  container: {
    padding: '0px',
    maxWidth: '900px',
  },
  title: {
    marginTop: '20px',
    marginBottom: '30px',
    fontWeight: 'bold',
    borderBottom: '2px solid #dee2e6',
    paddingBottom: '10px',
  },
  mb3: {
    marginBottom: '16px',
  },
  label: {
    display: 'block',
    marginBottom: '8px',
    fontWeight: 500,
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #ced4da',
    borderRadius: '6px',
    boxSizing: 'border-box',
  },
  select: {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #ced4da',
    borderRadius: '6px',
    boxSizing: 'border-box',
    background: '#fff',
  },
  submitButton: {
    background: '#0d6efd',
    color: '#fff',
    border: 'none',
    padding: '10px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
  },
  successAlert: {
    marginBottom: '16px',
    padding: '12px 14px',
    background: '#d1e7dd',
    color: '#0f5132',
    border: '1px solid #badbcc',
    borderRadius: '6px',
  },
  dangerAlert: {
    marginBottom: '16px',
    padding: '12px 14px',
    background: '#f8d7da',
    color: '#842029',
    border: '1px solid #f5c2c7',
    borderRadius: '6px',
  },
};

export default SellerCategoryAdd;